import { render, staticRenderFns } from "./AdminSocial.vue?vue&type=template&id=32daa868"
import script from "./AdminSocial.vue?vue&type=script&lang=js"
export * from "./AdminSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports